import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { navItems, practice } from '../data/site';
import { scrollToSection } from '../utils/scrollToSection';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);
  function handleMobileNav(event: React.MouseEvent<HTMLAnchorElement>, href: string) {
    scrollToSection(event, href, () => setMenuOpen(false));
  }
  return <header className={`fixed inset-x-0 top-0 z-[60] border-b transition-[background-color,border-color,backdrop-filter] duration-500 ${scrolled || menuOpen ? 'border-white/10 bg-ink' : 'border-white/[0.07] bg-ink/40 backdrop-blur-md'}`} data-id="element-285" data-mp="3f9dqgjzi6pkq">
      <div className="mx-auto flex h-[72px] max-w-shell items-center justify-between px-5 sm:px-8 lg:h-[84px] lg:px-12" data-id="element-286" data-mp="2mordn59kqmad">
        <Logo data-id="element-287" data-mp="3fbcaumcqdslu" />

        <nav aria-label="Main navigation" className="hidden xl:block" data-id="element-288" data-mp="3fbvjtdkel6nq">
          <ul className="flex items-center gap-6" data-id="element-289" data-mp="3ac97r7gb9wgi">
            {navItems.map(item => <li key={item.label} data-id="element-290" data-mp="3aelnddyljuqe">
                <a href={item.href} onClick={event => scrollToSection(event, item.href)} className={`nav-link inline-flex items-center gap-1.5 text-[13.5px] font-medium tracking-wide transition-colors ${item.accent ? 'text-accent hover:text-white' : 'text-white/75 hover:text-white'}`} data-id="element-291" data-mp="35kr6sjeafvvj">
                  {item.accent && <span aria-hidden="true" className="h-1 w-1 rounded-full bg-accent" data-id="element-292" data-mp="1recyjpoudboq" />}
                  {item.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="flex items-center gap-2 sm:gap-4" data-id="element-293" data-mp="1hlxgksdjon3u">
          <a href={practice.phoneHref} className="hidden min-h-[44px] items-center gap-2 text-[14px] font-medium text-white/85 transition-colors hover:text-white lg:flex" data-id="element-294" data-mp="1mljtf0pgo1c4">
            <PhoneIcon aria-hidden="true" className="h-4 w-4" strokeWidth={1.75} data-id="element-295" data-mp="1cq8dif2bgo2s" />
            {practice.phone}
          </a>
          <a href={practice.phoneHref} aria-label={`Call Lima Dental Group at ${practice.phone}`} className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-white lg:hidden" data-id="element-296" data-mp="yr0ebm65lfyl">
            <PhoneIcon aria-hidden="true" className="h-4 w-4" strokeWidth={1.75} data-id="element-297" data-mp="2y0yqe4ho6t78" />
          </a>
          <a href={practice.bookingUrl} target="_blank" rel="noreferrer" className="hidden min-h-[44px] items-center rounded-[8px] bg-white px-5 text-[14px] font-medium text-ink transition-all duration-300 hover:shadow-[0_0_0_3px_rgba(255,255,255,0.12)] sm:flex" data-id="element-298" data-mp="mfpsa5wkhoiz">
            Book appointment
          </a>
          <a href={practice.bookingUrl} target="_blank" rel="noreferrer" className="flex min-h-[44px] items-center rounded-[8px] bg-white px-4 text-[13px] font-medium text-ink sm:hidden" data-id="element-299" data-mp="154w4da2uvhvt">
            Book
          </a>
          <button type="button" onClick={() => setMenuOpen(o => !o)} aria-expanded={menuOpen} aria-controls="mobile-nav" aria-label={menuOpen ? 'Close menu' : 'Open menu'} className="flex h-11 w-11 items-center justify-center text-white xl:hidden" data-id="element-300" data-mp="1f0zh19vc2yx0">
            {menuOpen ? <XIcon aria-hidden="true" className="h-6 w-6" strokeWidth={1.5} data-id="element-301" data-mp="22xvsiizdxbrp" /> : <MenuIcon aria-hidden="true" className="h-6 w-6" strokeWidth={1.5} data-id="element-302" data-mp="27wgryg6tbrf3" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-303" data-mp="2cv0g8n8vpfam">
        {menuOpen && <motion.nav id="mobile-nav" aria-label="Mobile navigation" className="overflow-hidden border-t border-white/10 bg-ink xl:hidden" initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: [0.2, 0.8, 0.2, 1]
      }} data-id="element-304" data-mp="2gxf09aoaal3h">
            <ul className="max-h-[70vh] overflow-y-auto px-5 py-4 sm:px-8" data-id="element-305" data-mp="1y0m2b1468w2t">
              {navItems.map(item => <li key={item.label} className="border-b border-white/[0.07] last:border-0" data-id="element-306" data-mp="11h6bv3jfbwaq">
                  <a href={item.href} onClick={event => handleMobileNav(event, item.href)} className={`flex min-h-[52px] items-center gap-2 text-[16px] ${item.accent ? 'text-accent' : 'text-white/85'}`} data-id="element-307" data-mp="15hqa6afqh5yg">
                    {item.accent && <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-accent" data-id="element-308" data-mp="k0ser61fbu2r" />}
                    {item.label}
                  </a>
                </li>)}
            </ul>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}